import { ChangeDetectorRef, Component, effect, ElementRef, signal, untracked, ViewChild } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';


export class SpinnerText {
  text: string = '';
  text1?: string;
  text2?: string;
  class?: string;
}
@Component({
  selector: 'app-loader',
  standalone: true,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  @ViewChild('loaderDialog') loaderDialog!: ElementRef<HTMLDialogElement>;
  percent = signal(0);
  localText = signal<any>({ text: '' });
  isRunning = false;
  isCalculating = false;

  constructor(private loaderSvc: LoaderService, private cdr: ChangeDetectorRef) {
    effect(() => {
      const isLoading = this.loaderSvc.isLoading();
      const serviceText = this.loaderSvc.text();

      untracked(() => {
        if (isLoading) {
          this.updateTextSafely(serviceText);
          if (!this.isRunning) this.openLoader();
        } else {
          this.closeLoader();
        }
      });
    });
  }

  private updateTextSafely(newText: any) {
    // Microtarea para el texto
    Promise.resolve().then(() => {
      this.localText.set(newText);
    });
  }

  private openLoader() {
    this.isRunning = true;

    // IMPORTANTE: El reset a 0 debe ser asíncrono para evitar el NG0100
    Promise.resolve().then(() => {
      this.percent.set(0);
    });

    setTimeout(() => {
      if (this.loaderDialog && !this.loaderDialog.nativeElement.open) {
        this.loaderDialog.nativeElement.showModal();
        this.calcPorcentaje();
      }
    }, 0);
  }

  private calcPorcentaje() {
    if (!this.isRunning || this.isCalculating) return;
    this.isCalculating = true;

    if (this.percent() < 90) {
      // Actualizamos la señal
      this.percent.update(v => v + 1);

      let delay = this.percent() > 90 ? 800 : (this.percent() > 50 ? 300 : 50);

      setTimeout(() => {
        this.isCalculating = false;
        this.calcPorcentaje();
      }, delay);
    }
  }

  private closeLoader() {
    this.isRunning = false;

    // Salto inmediato elegante
    this.percent.set(100);

    setTimeout(() => {
      if (this.loaderDialog?.nativeElement.open) {
        this.loaderDialog.nativeElement.close();
      }

      this.percent.set(0);
      this.isCalculating = false;
    }, 150);
  }
}
